import styled, { css } from 'styled-components';
import { themeColor, whenThemePropEqualsTrue } from '../../../theme/getters';
import { modalLink, smallParagraph } from '../../../theme/typography';

const whenIsChecked = whenThemePropEqualsTrue('isChecked');
const whenHasError = whenThemePropEqualsTrue('hasError');

const getCheckedCheckStyles = whenIsChecked(
  () => css`
    transform: scale(1);
  `
);

const getErrorCheckBoxStyles = whenHasError(
  () => css`
    border-color: ${themeColor('error')};
  `
);

const getErrorTextStyles = whenHasError(
  () => css`
    color: ${themeColor('error')};
  `
);

export const Container = styled.button.attrs(() => ({
  type: 'button',
}))`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: flex-start;
  background: transparent;
  box-shadow: none;
  padding: 0;
  border: 0;
`;

export const CheckBox = styled.div`
  position: relative;
  width: 12px;
  height: 12px;
  border: 1px solid ${themeColor('white')};
  border-radius: 50%;
  margin: 0 7px 0 0;

  ${getErrorCheckBoxStyles};
`;

export const Check = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: white;
  border-radius: 50%;
  transform: scale(0);
  transition: transform ease-in-out 0.3s;

  ${getCheckedCheckStyles};
`;

export const Text = styled.span`
  flex: 1;
  ${smallParagraph};
  color: ${themeColor('gray')};
  text-align: left;

  ${getErrorTextStyles};

  a {
    ${modalLink};
    position: initial;
    color: ${themeColor('gray')};

    &:after {
      background: ${themeColor('gray')};
    }
  }
`;
